module.exports = __webpack_public_path__ + "img/16.15c05fcf.png";